<template>
  <span>
    <span>{{subscript}}</span>
  </span>
</template>

<script>
export default {
  props: {
    scope: Object
  },
  data() {
    return {

    }
  },
  computed: {
    subscript() {
      const { customPaginationOpt, index } = this.scope
      const idx = index + 1
      if(customPaginationOpt) {
        const { page, pageSize } = customPaginationOpt
        if(page && pageSize) {
          return ((page - 1) * pageSize) + idx 
        }
      }
      return idx
    }
  }
}
</script>